import { LayoutGrid, List, Clock, CalendarDays } from "lucide-react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

const tabs = [
  { id: "board", label: "Board", icon: LayoutGrid },
  { id: "list", label: "List", icon: List },
  { id: "timeline", label: "Timeline", icon: Clock },
  { id: "tentative", label: "Tentative Discharge", icon: CalendarDays },
];

interface TabMenuProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const TabMenu = ({ activeTab, onTabChange }: TabMenuProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="bg-card border-b border-border">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-start space-x-6">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = tab.id === activeTab;

            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={cn(
                  "flex items-center space-x-2 px-1 py-3 text-sm font-medium transition-colors relative min-h-[48px] min-w-[48px]",
                  isActive ? "text-primary" : "text-muted-foreground hover:text-foreground",
                )}
              >
                <Icon className="w-4 h-4" />
                {(!isMobile || isActive) && <span>{tab.label}</span>}
                {isActive && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
